const reasons = [
  {
    icon: "ri-battery-charge-line",
    title: "LFP Battery Chemistry",
    desc: "EcoFlow uses Lithium Iron Phosphate (LFP) batteries — safer, longer-lasting, and more stable than standard lithium-ion. Rated for 3,000–4,000+ charge cycles.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Industry-Leading Charge Speed",
    desc: "X-Stream technology charges the DELTA 2 from 0 to 80% in just 50 minutes — faster than any competitor in its class.",
  },
  {
    icon: "ri-expand-up-down-line",
    title: "Modular & Expandable",
    desc: "Start with a base unit and expand capacity as your needs grow. The DELTA Pro scales from 3.6kWh all the way to 25kWh with Smart Extra Batteries.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Smart App Control",
    desc: "Monitor energy usage, set charging schedules, and control your system remotely via the EcoFlow app on iOS and Android.",
  },
  {
    icon: "ri-sun-line",
    title: "Solar-Ready Out of the Box",
    desc: "Every EcoFlow unit supports solar panel input. Pair with EcoFlow's 220W–400W panels for a complete off-grid or backup solar system.",
  },
  {
    icon: "ri-home-wifi-line",
    title: "Whole-Home Integration",
    desc: "The Smart Home Panel 2 integrates directly with your home&apos;s electrical panel, enabling seamless automatic switching during outages.",
  },
];

const awards = [
  { label: "CES Innovation Award", year: "2023" },
  { label: "Red Dot Design Award", year: "2022" },
  { label: "TIME Best Inventions", year: "2022" },
  { label: "4M+ Units Sold", year: "Worldwide" },
];

export default function EcoFlowWhy() {
  return (
    <section className="py-20 px-4 md:px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-500 text-xs font-bold uppercase tracking-widest mb-3">Why EcoFlow</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
            The World&apos;s Most Advanced<br />Portable Power Brand
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            EcoFlow has redefined what&apos;s possible in portable and home backup power. Here&apos;s why millions of homeowners trust them.
          </p>
        </div>

        {/* Awards strip */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-14">
          {awards.map((a) => (
            <div
              key={a.label}
              className="flex items-center gap-2.5 bg-white border border-gray-100 rounded-full px-5 py-2.5"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-award-line text-amber-500 text-base"></i>
              </div>
              <div>
                <span className="text-gray-900 font-bold text-xs">{a.label}</span>
                <span className="text-gray-400 text-xs ml-1.5">{a.year}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Reasons grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((r) => (
            <div key={r.title} className="bg-white border border-gray-100 rounded-xl p-6">
              <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-xl mb-4">
                <i className={`${r.icon} text-amber-500 text-xl`}></i>
              </div>
              <h3 className="text-gray-900 font-bold text-base mb-2">{r.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* Image strip */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2 h-64 rounded-xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/90a988db259fe048519a8d5daf7f736e.jpg"
              alt="EcoFlow DELTA Pro powering a home during an outage"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="h-64 rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=EcoFlow%20solar%20panels%20on%20rooftop%20with%20DELTA%20Pro%20power%20station%20in%20garage%2C%20clean%20energy%20home%20setup%2C%20bright%20sunny%20day%2C%20modern%20house%2C%20premium%20solar%20energy%20lifestyle%20photography&width=400&height=400&seq=ecoflow-why-solar-v1&orientation=squarish"
              alt="EcoFlow solar panels and power station home energy system"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
